"use client";

import Image from "next/image";
import React, { useState, useRef } from "react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronRight, Quote, Star, X, ChevronLeft, Play, Pause } from "lucide-react";
import Review_Layout1 from "./Reviews/Layout1";
import Review_Layout2 from "./Reviews/Layout2";

interface User {
  name: string;
  designation: string;
  tasks: string;
}

interface ReviewProps {
  data: {
    id: number;
    title: string;
    description: string;
    reviewCard: User[];
    isLive: boolean;
    useH1Tag?: boolean;
  };
}



export default function ReviewsSection({ data }: ReviewProps) {
  if (!data.isLive) return null;
  return (
    <Review_Layout2 data={data} />
  );
}